import { Tree } from "@ecologi/shared";
import { DateTime } from "luxon";

export const treeStackMapper = (treeValue?: number) => {
  if (!treeValue || treeValue === 1) {
    return 0;
  } else if (treeValue === 2) {
    return 1;
  } else if (treeValue < 250) {
    return 2;
  } else if (treeValue < 500) {
    return 3;
  } else if (treeValue < 1000) {
    return 4;
  } else if (treeValue < 5000) {
    return 5;
  } else if (treeValue < 10000) {
    return 6;
  }
  return 7;
};

export const treeGraphicMapper = [
  // First month
  [
    "month1SingleTree",
    "month1DoubleTree",
    "month1TripleTree",
    "month1Trees5",
    "month1Trees6",
    "month1Trees7",
    "month1Trees8",
    "month1Trees17",
  ],
  // Second month
  [
    "month2SingleTree",
    "month2DoubleTree",
    "month2TripleTree",
    "month2Trees5",
    "month2Trees6",
    "month2Trees7",
    "month2Trees8",
    "month2Trees17",
  ],
  // Month three
  [
    "month3SingleTree",
    "month3DoubleTree",
    "month3TripleTree",
    "month3Trees5",
    "month3Trees6",
    "month3Trees7",
    "month3Trees8",
    "month3Trees17",
  ],
  // Month four
  [
    "month4SingleTree",
    "month4DoubleTree",
    "month4TripleTree",
    "month4Trees5",
    "month4Trees6",
    "month4Trees7",
    "month4Trees8",
    "month4Trees17",
  ],
  // Month five
  [
    "month5SingleTree",
    "month5DoubleTree",
    "month5TripleTree",
    "month5Trees5",
    "month5Trees6",
    "month5Trees7",
    "month5Trees8",
    "month5Trees17",
  ],
];

export const getTileKeyName = (tree: Tree) => {
  const today = DateTime.fromJSDate(new Date());
  const createdAt = DateTime.fromJSDate(new Date(tree.createdAt));
  const diffFromToday = today.diff(createdAt, "months");
  const ageOfTreesInMonths = Math.floor(diffFromToday.months);
  const treeMonthNumber =
    ageOfTreesInMonths < treeGraphicMapper.length
      ? ageOfTreesInMonths
      : treeGraphicMapper.length - 1;
  const treeStackNumber = treeStackMapper(tree.value);
  const tileType =
    treeGraphicMapper[treeMonthNumber]?.[treeStackNumber] ||
    // Fallback if for some reason the value cannot be indexed
    "month5Trees17";
  const treeDividendName = `${tileType.substring(0, 6)}TreeDividend`;

  return tree.isDividend ? treeDividendName : tileType;
};

export const getBirthdayTreeSVGs = (year: string) => ({
  month1SingleTree: `/images/app/forest/birthday/${year}/1.svg`,
  month2SingleTree: `/images/app/forest/birthday/${year}/2.svg`,
  month3SingleTree: `/images/app/forest/birthday/${year}/3.svg`,
  month4SingleTree: `/images/app/forest/birthday/${year}/4.svg`,
  month5SingleTree: `/images/app/forest/birthday/${year}/5.svg`,
});

export const treeFlagMapper = {
  AU: "/images/app/forest/flags/au.svg",
  BR: "/images/app/forest/flags/br.svg",
  UK: "/images/app/forest/flags/uk.svg",
  US: "/images/app/forest/flags/us.svg",
};
